import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import * as headers from '@/helpers/headers';
import Vue from 'vue';

const state = {
  current_poll: {},
  current_poll_answers: [],
  current_poll_user_answer: [],
  polls: [],
  pagination: {},
  loading: false,
  answer_loading: false,
  update_loading: false,
};

const getters = {
  getOnePoll: (state) => state.current_poll,
  getOnePollAnswers: (state) => state.current_poll_answers,
  getOnePollUserAnswers: (state) => state.current_poll_user_answer,
  getAllPoll: (state) => state.polls,
  getPollLoading: (state) => state.loading,
  getAnswerLoading: (state) => state.answer_loading,
  getUpdateLoading: (state) => state.update_loading,
  getPollPagination: (state) => state.pagination,
};

const actions = {
  getPolls(
    { commit, rootState },
    {
      pollId = null,
      pollUniqueId = null,
      pollName = null,
      currentPage = 1,
      sortBy = null,
      asc = null,
      startDate,
      endDate,
    } = {}
  ) {
    let r = Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
    commit('SET_LOADING', true);
    return new Promise(() => {
      let url = process.env.VUE_APP_GET_POLLS;
      let page = currentPage ? currentPage : 1;
      url = url + '?page=' + page;

      if (startDate != null && startDate !== 'undefined') {
        url = url + '&dateFrom=' + startDate;
      }

      if (endDate != null && endDate !== 'undefined') {
        url = url + '&dateTo=' + endDate;
      }

      if (pollId != null) {
        url = url + '&pollId=' + pollId;
      }

      if (pollName != null) {
        url = url + '&pollName=' + pollName;
      }

      if (pollUniqueId != null) {
        url = url + '&pollUniqueId=' + pollUniqueId;
      }

      if (sortBy != null && asc != null) {
        url = url + '&sortBy=' + sortBy + '&sortDirection=' + asc;
      }
      axios
        .get(
          url + '&r=' + r,
          headers.createHeaders(
            rootState.user.token,
            process.env.VUE_APP_TOKEN_VALUE
          )
        )
        .then((res) => {
          let polls = [];
          res.data.data.forEach((item) => {
            item.is_sponsored = item.is_sponsored === 1 ? 'Yes' : 'No';
            item.random = item.random === 1 ? 'Yes' : 'No';
            polls.push(item);
          });
          commit('SET_POLL_LIST', polls);
          commit('SET_PAGINATION', res.data.pagination);
          commit('SET_LOADING', false);
        })
        .catch((err) => {
          console.log(err);
          let message = 'Check console for more info';
          let title = 'Error';
          if (err.response.status == 401) {
            message = 'Unauthorized. Check console for more info';
            title = 'Unauthorized';
          }
          Vue.notify({
            group: 'error',
            title: title,
            type: 'error',
            text: `${err.response.status} : ${message}`,
            duration: -1,
            position: 'bottom right',
            closeOnClick: true,
          });
          console.log(err);
          commit('SET_LOADING', false);
          Bugsnag.notify(err);
        });
    });
  },
  getPoll({ commit, rootState }, id) {
    let r = Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
    commit('SET_LOADING', true);
    axios
      .get(
        process.env.VUE_APP_GET_ONE_POLL + id + '?r=' + r,
        headers.createHeaders(
          rootState.user.token,
          process.env.VUE_APP_TOKEN_VALUE
        )
      )
      .then((res) => {
        let poll = res.data.data[0];
        poll.is_sponsored = poll.is_sponsored === 1 ? 'Yes' : 'No';
        poll.random = poll.random === 1 ? 'Yes' : 'No';
        commit('SET_ONE_POLL', poll);
        commit('SET_ONE_POLL_ANSWERS', res.data.data[0].answers);
        commit('SET_ONE_POLL_USER_ANSWERS', res.data.data[0].user_answers);
        commit('SET_LOADING', false);
      })
      .catch((err) => {
        console.log(err.status.data);
        let message = 'Check console for more info';
        let title = 'Error';
        if (err.response.status == 401) {
          message = 'Unauthorized. Check console for more info';
          title = 'Unauthorized';
        }
        Vue.notify({
          group: 'error',
          title: title,
          type: 'error',
          text: `${err.response.status} : ${message}`,
          duration: -1,
          position: 'bottom right',
          closeOnClick: true,
        });
        console.log(err);
        commit('SET_LOADING', false);
        Bugsnag.notify(err);
      });
  },
  updatePoll({ commit, rootState }, poll) {
    commit('SET_GENERAL_LOADING', true);
    return new Promise((resolve, reject) => {
      axios
        .put(
          process.env.VUE_APP_UPDATE_POLL + poll.id,
          poll,
          headers.createHeaders(
            rootState.user.token,
            process.env.VUE_APP_TOKEN_VALUE
          )
        )
        .then((res) => {
          let updPoll = res.data[0];
          updPoll.is_sponsored = updPoll.is_sponsored === 1 ? 'Yes' : 'No';
          updPoll.random = updPoll.random === 1 ? 'Yes' : 'No';
          commit('SET_UPDATE_POLL', updPoll);
          commit('SET_ONE_POLL', updPoll);
          alert('Poll was successfully updated!');
          commit('SET_GENERAL_LOADING', false);
          resolve(res);
        })
        .catch((err) => {
          console.log(err.response.data);
          let message = 'Check console for more info';
          let title = 'Error';
          if (err.response.status == 401) {
            message = 'Unauthorized. Check console for more info';
            title = 'Unauthorized';
          }
          Vue.notify({
            group: 'error',
            title: title,
            type: 'error',
            text: `${err.response.status} : ${message}`,
            duration: -1,
            position: 'bottom right',
            closeOnClick: true,
          });
          console.log(err);
          commit('SET_GENERAL_LOADING', false);
          Bugsnag.notify(err);
          reject(err);
        });
    });
  },
  async archivePoll({ commit, rootState }, poll) {
    let status = poll.status;
    commit('SET_LOADING', true);
    var success = false;
    await axios
      .put(
        process.env.VUE_APP_ARCHIVE_POLL + poll.id,
        poll,
        headers.createHeaders(
          rootState.user.token,
          process.env.VUE_APP_TOKEN_VALUE
        )
      )
      .then((res) => {
        commit('SET_UPDATE_POLL', res.data);
        if (status === 'archived') {
          alert('Poll was successfully archived!');
        } else {
          alert('Poll was successfully activated!');
        }
        success = true;
        commit('SET_LOADING', false);
      })
      .catch((err) => {
        console.log(err.response.data);
        let message = 'Check console for more info';
        let title = 'Error';
        if (err.response.status == 401) {
          message = 'Unauthorized. Check console for more info';
          title = 'Unauthorized';
        }
        Vue.notify({
          group: 'error',
          title: title,
          type: 'error',
          text: `${err.response.status} : ${message}`,
          duration: -1,
          position: 'bottom right',
          closeOnClick: true,
        });
        console.log(err);
        commit('SET_LOADING', false);
        Bugsnag.notify(err);
      });
    return success;
  },
  addPollAnswer({ commit, rootState }, answer) {
    commit('SET_ANSWER_LOADING', true);
    return new Promise((resolve, reject) => {
      axios
        .post(
          process.env.VUE_APP_CREATE_POLL_ANSWER,
          answer,
          headers.createHeaders(
            rootState.user.token,
            process.env.VUE_APP_TOKEN_VALUE
          )
        )
        .then((res) => {
          alert('Answer created successfully');
          commit('SET_NEW_TO_CURRENT_ANSWER', res.data[0]);
          commit('SET_ANSWER_LOADING', false);
          resolve(res);
        })
        .catch((err) => {
          console.log(err.response.data);
          let message = 'Check console for more info';
          let title = 'Error';
          if (err.response.status == 401) {
            message = 'Unauthorized. Check console for more info';
            title = 'Unauthorized';
          }
          Vue.notify({
            group: 'error',
            title: title,
            type: 'error',
            text: `${err.response.status} : ${message}`,
            duration: -1,
            position: 'bottom right',
            closeOnClick: true,
          });
          commit('SET_ANSWER_LOADING', false);
          console.log(err);
          Bugsnag.notify(err);
          reject(err);
        });
    });
  },
  updateAnswer({ commit, rootState }, answer) {
    commit('SET_ANSWER_LOADING', true);
    return new Promise((resolve, reject) => {
      axios
        .put(
          process.env.VUE_APP_UPDATE_POLL_ANSWER + answer.id,
          answer,
          headers.createHeaders(
            rootState.user.token,
            process.env.VUE_APP_TOKEN_VALUE
          )
        )
        .then((res) => {
          commit('SET_UPDATE_ANSWER', res.data);
          alert('Answer updated successfully');
          commit('SET_ANSWER_LOADING', false);
          resolve(res);
        })
        .catch((err) => {
          console.log(err.response.data);
          let message = 'Check console for more info';
          let title = 'Error';
          if (err.response.status == 401) {
            message = 'Unauthorized. Check console for more info';
            title = 'Unauthorized';
          }
          Vue.notify({
            group: 'error',
            title: title,
            type: 'error',
            text: `${err.response.status} : ${message}`,
            duration: -1,
            position: 'bottom right',
            closeOnClick: true,
          });
          console.log(err);
          commit('SET_ANSWER_LOADING', false);
          Bugsnag.notify(err);
          reject(err);
        });
    });
  },
  deleteAnswer({ commit, rootState }, id) {
    commit('SET_ANSWER_LOADING', true);
    axios
      .delete(
        process.env.VUE_APP_DELETE_POLL_ANSWER + id,
        headers.createHeaders(
          rootState.user.token,
          process.env.VUE_APP_TOKEN_VALUE
        )
      )
      .then(() => {
        commit('SET_REMOVE_ANSWER', id);
        alert('Answer was successfully deleted!');
        commit('SET_ANSWER_LOADING', false);
      })
      .catch((err) => {
        console.log(err.response.data);
        let message = 'Check console for more info';
        let title = 'Error';
        if (err.response.status == 401) {
          message = 'Unauthorized. Check console for more info';
          title = 'Unauthorized';
        }
        Vue.notify({
          group: 'error',
          title: title,
          type: 'error',
          text: `${err.response.status} : ${message}`,
          duration: -1,
          position: 'bottom right',
          closeOnClick: true,
        });
        console.log(err);
        commit('SET_ANSWER_LOADING', false);
        Bugsnag.notify(err);
      });
  },
};

const mutations = {
  SET_LOADING: (state, val) => (state.loading = val),
  SET_ANSWER_LOADING: (state, val) => (state.answer_loading = val),
  SET_ALL_POLLS: (state, pollItems) => (state.polls = pollItems),
  SET_POLL_LIST: (state, list) => (state.polls = list),
  SET_REMOVE_POLL: (state, pollID) =>
    (state.polls = state.polls.filter((poll) => poll.id !== pollID)),
  SET_UPDATE_POLL: (state, updPoll) => {
    const index = state.polls.findIndex((poll) => poll.id == updPoll.id);
    if (index !== -1) {
      state.polls.splice(index, 1, updPoll);
    }
  },
  SET_NEW_POLL: (state, newPoll) => state.polls.unshift(newPoll),
  SET_ONE_POLL: (state, poll) => (state.current_poll = poll),
  SET_ONE_POLL_ANSWERS: (state, ans) => (state.current_poll_answers = ans),
  SET_ONE_POLL_USER_ANSWERS: (state, user_ans) =>
    (state.current_poll_user_answer = user_ans),
  SET_CLEAR_ONE_POLL: (state) => {
    state.current_poll = {};
    state.current_poll_answers = [];
  },
  SET_NEW_TO_CURRENT_ANSWER: (state, newAns) =>
    state.current_poll_answers.push(newAns),
  SET_UPDATE_ANSWER: (state, updAns) => {
    const index = state.current_poll_answers.findIndex(
      (ans) => ans.id === updAns.id
    );
    if (index !== -1) {
      state.current_poll_answers.splice(index, 1, updAns);
    }
  },
  SET_REMOVE_ANSWER: (state, id) => {
    state.current_poll_answers = state.current_poll_answers.filter(
      (ans) => ans.id !== id
    );
  },
  SET_PAGINATION: (state, pagination) => (state.pagination = pagination),
  SET_UPDATE_LOADING: (state, val) => (state.update_loading = val),
  SET_FILTER_POLLS: (state, val) => {
    console.log(`Val sent : ${val}`);
    if (val !== '') {
      let search;
      if (val.includes('y') || val.includes('Y')) {
        search = 1;
      }
      state.polls = state.polls.filter((poll) => poll.is_sponsored === search);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
